
export const featuredContent = [
  {
    id: 1,
    title: 'El Último Horizonte',
    type: 'Película',
    genre: 'Ciencia Ficción',
    year: 2024,
    rating: 4.8,
    image: 'https://public.readdy.ai/ai/img_res/b8e8ed7a4ce195e88098c2f6801a25d6.jpg',
    description: 'Una épica aventura espacial que redefine los límites de la exploración humana en el cosmos desconocido.',
    match: 95
  },
  {
    id: 2,
    title: 'Sombras del Pasado',
    type: 'Serie',
    genre: 'Drama',
    year: 2024,
    rating: 4.6,
    image: 'https://readdy.ai/api/search-image?query=dramatic%20tv%20series%20poster%20with%20mysterious%20silhouettes%20in%20foggy%20urban%20setting%20dark%20moody%20atmosphere%20cinematic%20lighting%20professional%20poster%20design&width=800&height=1200&seq=2&orientation=portrait',
    description: 'Un thriller psicológico que explora los secretos más oscuros de una familia aparentemente perfecta.',
    match: 88
  },
  {
    id: 3,
    title: 'Crónicas de Akira',
    type: 'Anime',
    genre: 'Acción',
    year: 2024,
    rating: 4.9,
    image: 'https://readdy.ai/api/search-image?query=epic%20anime%20poster%20with%20heroic%20character%20in%20dynamic%20action%20pose%20vibrant%20colors%20japanese%20animation%20style%20dramatic%20sky%20background%20professional%20anime%20artwork&width=800&height=1200&seq=3&orientation=portrait',
    description: 'Una historia de samuráis modernos que luchan por proteger su ciudad de fuerzas sobrenaturales.',
    match: 92
  },
  {
    id: 4,
    title: 'Amor en Tiempos Modernos',
    type: 'Novela',
    genre: 'Romance',
    year: 2024,
    rating: 4.5,
    image: 'https://readdy.ai/api/search-image?query=romantic%20drama%20poster%20with%20couple%20silhouette%20at%20sunset%20warm%20golden%20lighting%20emotional%20atmosphere%20professional%20romance%20poster%20design&width=800&height=1200&seq=4&orientation=portrait',
    description: 'Una conmovedora historia de amor que atraviesa continentes y desafía todas las expectativas.',
    match: 85
  },
  {
    id: 5,
    title: 'El Código Secreto',
    type: 'Libro',
    genre: 'Misterio',
    year: 2024,
    rating: 4.7,
    image: 'https://readdy.ai/api/search-image?query=mystery%20thriller%20book%20cover%20with%20cryptic%20symbols%20and%20ancient%20manuscripts%20dark%20atmospheric%20lighting%20professional%20book%20cover%20design&width=800&height=1200&seq=5&orientation=portrait',
    description: 'Un enigma histórico que podría cambiar todo lo que sabemos sobre la civilización antigua.',
    match: 90
  },
  {
    id: 6,
    title: 'Reinos Olvidados',
    type: 'Serie',
    genre: 'Fantasía',
    year: 2024,
    rating: 4.8,
    image: 'https://readdy.ai/api/search-image?query=epic%20fantasy%20series%20poster%20with%20medieval%20castle%20and%20magical%20elements%20mystical%20atmosphere%20dramatic%20clouds%20professional%20fantasy%20poster%20design&width=800&height=1200&seq=6&orientation=portrait',
    description: 'Una saga épica de magia, dragones y héroes destinados a salvar el mundo de la oscuridad.',
    match: 94
  }
];

export const catalogItems = [
  {
    id: 7,
    title: 'Noche de Terror',
    type: 'Película',
    genre: 'Terror',
    year: 2024,
    rating: 4.3,
    image: 'https://readdy.ai/api/search-image?query=horror%20movie%20poster%20with%20haunted%20house%20and%20eerie%20fog%20dark%20scary%20atmosphere%20professional%20horror%20poster%20design%20with%20dramatic%20shadows&width=800&height=1200&seq=7&orientation=portrait'
  },
  {
    id: 8,
    title: 'Risas sin Control',
    type: 'Serie',
    genre: 'Comedia',
    year: 2024,
    rating: 4.4,
    image: 'https://readdy.ai/api/search-image?query=comedy%20series%20poster%20with%20bright%20colorful%20design%20fun%20playful%20atmosphere%20professional%20comedy%20poster%20with%20vibrant%20colors&width=800&height=1200&seq=8&orientation=portrait'
  },
  {
    id: 9,
    title: 'Guerreros del Futuro',
    type: 'Anime',
    genre: 'Acción',
    year: 2023,
    rating: 4.6,
    image: 'https://readdy.ai/api/search-image?query=futuristic%20anime%20poster%20with%20mecha%20robots%20and%20neon%20cityscape%20cyberpunk%20style%20professional%20anime%20artwork%20with%20dynamic%20composition&width=800&height=1200&seq=9&orientation=portrait'
  },
  {
    id: 10,
    title: 'Secretos del Corazón',
    type: 'Novela',
    genre: 'Drama',
    year: 2024,
    rating: 4.5,
    image: 'https://readdy.ai/api/search-image?query=emotional%20drama%20poster%20with%20intimate%20scene%20soft%20lighting%20professional%20dramatic%20poster%20design%20with%20warm%20tones&width=800&height=1200&seq=10&orientation=portrait'
  },
  {
    id: 11,
    title: 'La Conspiración',
    type: 'Película',
    genre: 'Thriller',
    year: 2024,
    rating: 4.7,
    image: 'https://readdy.ai/api/search-image?query=political%20thriller%20poster%20with%20government%20buildings%20and%20shadowy%20figures%20tense%20atmosphere%20professional%20thriller%20poster%20design&width=800&height=1200&seq=11&orientation=portrait'
  },
  {
    id: 12,
    title: 'Mundos Paralelos',
    type: 'Libro',
    genre: 'Ciencia Ficción',
    year: 2024,
    rating: 4.8,
    image: 'https://readdy.ai/api/search-image?query=sci-fi%20book%20cover%20with%20parallel%20universes%20and%20quantum%20physics%20visualization%20futuristic%20design%20professional%20book%20cover&width=800&height=1200&seq=12&orientation=portrait'
  },
  {
    id: 13,
    title: 'Academia de Magia',
    type: 'Anime',
    genre: 'Fantasía',
    year: 2024,
    rating: 4.7,
    image: 'https://readdy.ai/api/search-image?query=magical%20school%20anime%20poster%20with%20young%20wizards%20and%20enchanted%20castle%20fantasy%20atmosphere%20professional%20anime%20artwork&width=800&height=1200&seq=13&orientation=portrait'
  },
  {
    id: 14,
    title: 'Destino Cruzado',
    type: 'Serie',
    genre: 'Romance',
    year: 2024,
    rating: 4.4,
    image: 'https://readdy.ai/api/search-image?query=romantic%20series%20poster%20with%20couple%20in%20beautiful%20landscape%20dreamy%20atmosphere%20professional%20romance%20poster%20design&width=800&height=1200&seq=14&orientation=portrait'
  },
  {
    id: 15,
    title: 'El Detective',
    type: 'Película',
    genre: 'Misterio',
    year: 2023,
    rating: 4.6,
    image: 'https://readdy.ai/api/search-image?query=detective%20noir%20poster%20with%20investigator%20in%20rainy%20city%20street%20mysterious%20atmosphere%20professional%20mystery%20poster%20design&width=800&height=1200&seq=15&orientation=portrait'
  },
  {
    id: 16,
    title: 'Viaje al Centro',
    type: 'Libro',
    genre: 'Aventura',
    year: 2024,
    rating: 4.5,
    image: 'https://readdy.ai/api/search-image?query=adventure%20book%20cover%20with%20explorer%20in%20exotic%20jungle%20landscape%20exciting%20atmosphere%20professional%20adventure%20book%20design&width=800&height=1200&seq=16&orientation=portrait'
  },
  {
    id: 17,
    title: 'Héroes Urbanos',
    type: 'Serie',
    genre: 'Acción',
    year: 2024,
    rating: 4.7,
    image: 'https://readdy.ai/api/search-image?query=urban%20action%20series%20poster%20with%20heroes%20in%20modern%20city%20dynamic%20composition%20professional%20action%20poster%20design&width=800&height=1200&seq=17&orientation=portrait'
  },
  {
    id: 18,
    title: 'Dimensión Desconocida',
    type: 'Película',
    genre: 'Ciencia Ficción',
    year: 2024,
    rating: 4.8,
    image: 'https://readdy.ai/api/search-image?query=sci-fi%20dimension%20portal%20poster%20with%20cosmic%20gateway%20and%20alien%20worlds%20mysterious%20atmosphere%20professional%20sci-fi%20poster&width=800&height=1200&seq=18&orientation=portrait'
  }
];

export const reviews = [
  {
    id: 1,
    contentTitle: 'El Último Horizonte',
    reviewer: 'María González',
    role: 'Crítica de Cine',
    rating: 5,
    text: 'Una obra maestra visual que combina efectos especiales impresionantes con una narrativa profundamente humana. La dirección es impecable y cada escena está cuidadosamente elaborada para mantener al espectador al borde de su asiento.',
    image: 'https://readdy.ai/api/search-image?query=cinematic%20sci-fi%20movie%20poster%20with%20futuristic%20spaceship%20and%20cosmic%20nebula%20background%20dark%20space%20atmosphere%20professional%20movie%20poster%20design%20with%20dramatic%20lighting%20and%20stars&width=600&height=900&seq=19&orientation=portrait',
    date: '15 Enero 2024'
  },
  {
    id: 2,
    contentTitle: 'Crónicas de Akira',
    reviewer: 'Carlos Ramírez',
    role: 'Experto en Anime',
    rating: 5,
    text: 'Este anime establece un nuevo estándar para la animación moderna. La fluidez de las escenas de acción es extraordinaria, y la profundidad emocional de los personajes te mantiene completamente involucrado en su viaje.',
    image: 'https://readdy.ai/api/search-image?query=epic%20anime%20poster%20with%20heroic%20character%20in%20dynamic%20action%20pose%20vibrant%20colors%20japanese%20animation%20style%20dramatic%20sky%20background%20professional%20anime%20artwork&width=600&height=900&seq=20&orientation=portrait',
    date: '10 Enero 2024'
  },
  {
    id: 3,
    contentTitle: 'Reinos Olvidados',
    reviewer: 'Ana Martínez',
    role: 'Crítica de Series',
    rating: 5,
    text: 'Una serie de fantasía épica que rivaliza con las mejores producciones del género. El desarrollo de personajes es excepcional y cada episodio te deja con ganas de más. La construcción del mundo es simplemente magistral.',
    image: 'https://readdy.ai/api/search-image?query=epic%20fantasy%20series%20poster%20with%20medieval%20castle%20and%20magical%20elements%20mystical%20atmosphere%20dramatic%20clouds%20professional%20fantasy%20poster%20design&width=600&height=900&seq=21&orientation=portrait',
    date: '5 Enero 2024'
  }
];

export const categories = [
  'Todos',
  'Películas',
  'Series',
  'Anime',
  'Novelas',
  'Libros'
];

export const genres = [
  'Todos los géneros',
  'Acción',
  'Aventura',
  'Ciencia Ficción',
  'Comedia',
  'Drama',
  'Fantasía',
  'Terror',
  'Misterio',
  'Romance',
  'Thriller'
];
